import { render, staticRenderFns } from "./xrefs.vue?vue&type=template&id=2e994d17&"
import script from "./xrefs.vue?vue&type=script&lang=js&"
export * from "./xrefs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports